<template>
  <FormulateForm
    name="createCompany"
    @submit="submitHandler"
    #default="{ isLoading }"
    v-model="formValues"
    data-cy="create-company-form"
  >
    <b-form>
      <b-form-group label="Company name" label-for="name">
        <FormulateInput
          id="name"
          name="name"
          type="text"
          validation="required"
          input-class="form-control"
          data-cy="name-input"
        />
      </b-form-group>
      <b-form-group label="Identification number" label-for="in">
        <FormulateInput
          id="in"
          name="in"
          type="text"
          input-class="form-control"
          data-cy="identification-number-input"
        />
      </b-form-group>
      <b-form-group label="Primary contact" label-for="primary_contact_id">
        <FormulateInput
          id="primaryContactId"
          name="primaryContactId"
          type="select"
          placeholder="Choose contact"
          data-cy="primary-contact-select"
          :options="
            contacts.map((u) => ({
              value: u.id,
              label: `${u.email} - ${u.first_name} ${u.last_name}`,
            }))
          "
        />
      </b-form-group>
      <b-form-group label="Business potential" label-for="businessPotential">
        <FormulateInput
          id="businessPotential"
          name="businessPotential"
          type="number"
          input-class="form-control"
          step="0.01"
          data-cy="business-potential-input"
        />
      </b-form-group>
      <b-form-group
        label="Business potential use"
        label-for="businessPotentialUse"
      >
        <FormulateInput
          id="businessPotentialUse"
          name="businessPotentialUse"
          type="number"
          input-class="form-control"
          step="0.01"
          data-cy="business-potential-use-input"
        />
      </b-form-group>
      <b-form-group
        label="Number of used products"
        label-for="numberOfUsedProducts"
      >
        <FormulateInput
          id="numberOfUsedProducts"
          name="numberOfUsedProducts"
          type="number"
          step="1"
          input-class="form-control"
          data-cy="number-of-used-products-input"
        />
      </b-form-group>
      <b-form-group
        label="Current monthly billing"
        label-for="currentBillingMonthly"
      >
        <FormulateInput
          id="currentBillingMonthly"
          name="currentBillingMonthly"
          type="number"
          step="0.01"
          input-class="form-control"
          data-cy="current-billing-monthly-input"
        />
      </b-form-group>
    </b-form>
    <b-row>
      <b-col col lg="4">
        <b-button
          block
          variant="outline-primary"
          @click="$router.push('/companies')"
          >Back to companies</b-button
        >
      </b-col>
      <b-col>
        <b-button
          block
          class="mt-0"
          type="submit"
          variant="primary"
          data-cy="submit-button"
          :disabled="isLoading"
          :label="isLoading ? 'Loading...' : 'Submit this form'"
          >Create company</b-button
        >
      </b-col>
    </b-row>
  </FormulateForm>
</template>

<script>
import gql from "graphql-tag";
const CREATE_COMPANY = gql`
  mutation createCompany(
    $name: String!
    $in: String
    $primaryContactId: uuid
    $businessPotential: float8
    $businessPotentialUse: float8
    $numberOfUsedProducts: Int
    $currentBillingMonthly: float8
  ) {
    insert_companies_one(
      object: {
        name: $name
        in: $in
        primary_contact_id: $primaryContactId
        business_potential: $businessPotential
        business_potential_use: $businessPotentialUse
        number_of_used_products: $numberOfUsedProducts
        current_billing_monthly: $currentBillingMonthly
      }
    ) {
      id
      name
      in
      primary_contact_id
      business_potential
      business_potential_use
      number_of_used_products
      current_billing_monthly
    }
  }
`;
const LIST_CONTACTS = gql`
  query listContacts {
    contacts {
      id
      email
      first_name
      last_name
    }
  }
`;

export default {
  name: "CompanyFormCreate",
  data() {
    return {
      formValues: {},
      contacts: [],
      isLoading: false
    };
  },
  apollo: {
    contacts() {
      return {
        query: LIST_CONTACTS
      };
    }
  },
  methods: {
    async submitHandler() {
      try {
        this.isLoading = true;
        const res = await this.$apollo.mutate({
          mutation: CREATE_COMPANY,
          variables: {
            name: this.formValues.name,
            in: this.formValues.in,
            primaryContactId: this.formValues.primaryContactId,
            businessPotential: parseFloat(this.formValues.businessPotential),
            businessPotentialUse: parseFloat(
              this.formValues.businessPotentialUse
            ),
            numberOfUsedProducts: parseInt(
              this.formValues.numberOfUsedProducts
            ),
            currentBillingMonthly: parseFloat(
              this.formValues.currentBillingMonthly
            )
          }
        });
        this.isLoading = false;
        this.$toast.success(`Company created`);
        this.$formulate.reset("createCompany");
        this.$emit("company-created", res.data.insert_companies_one);
      } catch (error) {
        this.isLoading = false;
        this.$toast.error(`Failed to create company: ${error.message}`);
      }
    }
  }
};
</script>
